import { render, staticRenderFns } from "./changeRFCCloseNumStatus.vue?vue&type=template&id=f3d4a838&scoped=true&"
import script from "./changeRFCCloseNumStatus.vue?vue&type=script&lang=js&"
export * from "./changeRFCCloseNumStatus.vue?vue&type=script&lang=js&"
import style0 from "./changeRFCCloseNumStatus.vue?vue&type=style&index=0&id=f3d4a838&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d4a838",
  null
  
)

export default component.exports